import React from "react";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

function InputDatePicker({
    value,
    onChange = date => {},
    minDate = undefined,
    maxDate = undefined,
    className = "",
    inputProps = { className: "", style: {} },
    InputLabelProps = {},
    id = "date-picker-inline",
    format = "dd/MM/yyyy",
    variant = "inline",
    label = "Date picker",
    autoOk = true,
    style = {},
}) {
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                autoOk={autoOk}
                disableToolbar
                inputVariant="outlined"
                size="small"
                variant={variant}
                format={format}
                margin="normal"
                className={`t-form-group-custom ${className}`}
                InputLabelProps={{ className: `t-form-group-custom ${InputLabelProps?.className}`, ...InputLabelProps }}
                inputProps={inputProps}
                maxDate={maxDate}
                minDate={minDate}
                id={id}
                label={label}
                value={value}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                    id: "datepicker",
                }}
                onChange={onChange}
                style={style}
            />
        </MuiPickersUtilsProvider>
    );
}

export default InputDatePicker;
